let config = null;

export const getConfig = async () => {
  if (config) return config;

  const response = await fetch("/apiEndpoints.json");
  config = await response.json();

  return config;
};